import { propOr } from 'ramda';
import { useGetGameByLaunchGameId } from '@namespace/games';
import { useI18n } from '@namespace/i18n';
import { normalizeJackpotWinBonusDetails } from '../../normalizers';
import { useBonusesStore } from '../../store';

const selectJackpotsWinsBonuses = () => propOr([], 'jackpotsWinsBonuses');

export const useJackpotWinBonus = (bonusId) => {
  const jackpotsWinsBonuses = useBonusesStore(selectJackpotsWinsBonuses());
  const { t, f } = useI18n();
  const bonusData = jackpotsWinsBonuses.find(({ id }) => id === bonusId);
  const { gameId } = bonusData || {};
  const { gameName, providerName } = useGetGameByLaunchGameId(gameId);

  return normalizeJackpotWinBonusDetails({
    bonusData,
    t,
    f,
    gameName,
    providerName
  });
};
